import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { safeJsonStringify, getPort } from '@/utils/tools';
import { getSource } from '@/utils';

// 基础参数
const BASE_PARAMS = {
  pageId: 'Welfare',
  categoryId: 'platform',
};

// 启动参数
let START_UP_PARAMS = {};

// 自定义事件类型基础参数
const OTHERS_BASE_PARAMS = {
  eventId: 'others',
  categoryId: 'platform',
};

// 获取基础业务参数
function getBaseBusinessInfo() {
  return {
    adsource: getSource(),
    port: getPort(),
    ...START_UP_PARAMS,
  };
}

// 启动参数
function startup(params = {}) {
  START_UP_PARAMS = params;
}

// 页面进入曝光
function pageView(params = {}) {
  console.log('>>>spm => pageView', safeJsonStringify(params));
  const { businessInfo = {} } = params || {};
  UBT.pageView({
    ...BASE_PARAMS,
    ...params,
    businessInfo: {
      ...getBaseBusinessInfo(),
      ...businessInfo,
    },
  });
}

// 页面离开曝光
function pageViewOut(params = {}) {
  console.log('>>>spm => pageViewOut', safeJsonStringify(params));
  const { businessInfo = {} } = params || {};
  UBT.pageViewOut({
    ...BASE_PARAMS,
    ...params,
    businessInfo: {
      ...getBaseBusinessInfo(),
      ...businessInfo,
    },
  });
}

// 模块曝光
function moduleExpose(params = {}) {
  console.log('>>>spm => moduleExpose', safeJsonStringify(params));
  const { businessInfo = {} } = params || {};
  UBT.moduleExpose({
    ...BASE_PARAMS,
    exposureTimes: 1,
    ...params,
    businessInfo: {
      ...getBaseBusinessInfo(),
      ...businessInfo,
    },
  });
}

// 模块点击
function clickButton(params = {}) {
  console.log('>>>spm => clickButton', safeJsonStringify(params));
  const { businessInfo = {} } = params || {};
  UBT.clickButton({
    ...BASE_PARAMS,
    ...params,
    businessInfo: {
      ...getBaseBusinessInfo(),
      ...businessInfo,
    },
  });
}

// 自定义事件曝光埋点
function customEventWithPointId(params = {}) {
  console.log('>>>spm => customEventWithPointId', safeJsonStringify(params));
  const { businessInfo = {} } = params || {};
  UBT.customEventWithPointId({
    ...OTHERS_BASE_PARAMS,
    ...params,
    businessInfo: {
      ...getBaseBusinessInfo(),
      ...businessInfo,
    },
  });
}

export default {
  pageView,
  pageViewOut,
  moduleExpose,
  clickButton,
  customEventWithPointId,
  startup,
};
